<template>
  <div class="w-100 p-2 mt-2">
    <page-header>
      <i class="fas fa-list"></i> {{ $t('page.title.security_groups') }}
      <template v-slot:right>
        <b-button @click="openModal('create')" size="sm" variant="success"> {{ $t('btn.add_group') }}</b-button>
      </template>
    </page-header>
    <page-card>
      <template v-slot:header>
        {{ $t('title.filters') }}
      </template>
      <template v-slot:content>
        <div class="row sygni-grid">
          <div class="col-6">
            <filter-input
                :filter-query="filterQuery"
                filter-name="phrase"
                filter-operator="like"
                :label="$t('filters.label.phrase')"
                :placeholder="$t('filters.placeholder.phrase')">
            </filter-input>
          </div>
        </div> <!-- #row-->
      </template>
      <template v-slot:footer>
        <b-button @click="resetFilters()" variant="secondary">{{$t('filters.btn.clear')}}</b-button>
        <b-button @click="applyFilters()" variant="primary">{{$t('filters.btn.apply')}}</b-button>
      </template>
    </page-card>

    <page-card>
      <template v-slot:header>
        {{ $t('title.list') }}
      </template>
      <template v-slot:content>

        <grid-pagination :total-count="totalCount"
                         :per-page="perPage"
                         :current-page="currentPage"
                         @load-items="paginationReload"></grid-pagination>

        <div class="table-responsive sygni-grid">
          <b-table striped show-empty
                   :empty-text="$t('table.no_results')"
                   :busy="isBusy"
                   hover
                   head-variant="dark"
                   outlined
                   :sort-by.sync="orderColumn"
                   :sort-desc.sync="orderDirection"
                   :no-local-sorting="true"
                   :items="items"
                   :fields="fields">
            <template #cell(rolesCount)="data">
              <div class="ml-2">
                {{ data.item.rolesCount }}
              </div>
            </template>
            <template #cell(actions)="data">
              <div class="table-action--cell">
                <b-button variant="primary" size="sm"
                          @click="showItemDetails(data.item)">
                  {{$t('table.btn.show')}}
                </b-button>
                <b-button

                    variant="success" size="sm"
                    @click="editItem(data.item)"
                >
                  {{$t('table.btn.edit')}}
                </b-button>
                <b-button
                    v-required-role="'ROLE_BACKOFFICE_GROUP_DELETE'"
                    variant="danger" size="sm"
                    @click="deleteItem(data.item)">
                  {{$t('table.btn.delete')}}
                </b-button>
              </div>
            </template>

            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>{{$t('state.loading')}}</strong>
              </div>
            </template>

          </b-table>
        </div> <!-- #table-responsive-->


        <grid-pagination :total-count="totalCount"
                         :per-page="perPage"
                         :current-page="currentPage"
                         @load-items="paginationReload"></grid-pagination>
      </template>
    </page-card>
  </div>
</template>

<script>
import FilterInput from "../../../../components/grid/filters/FilterInput";
import GridMixin from '../../../../components/grid/GridMixin';
import CreateSecurityGroupModal from "./CreateSecurityGroupModal";
import ShowSecurityGroupModal from "./ShowSecurityGroupModal";
import axios from "axios";
import alertify from 'alertifyjs';
import GridPagination from "../../../../components/grid/grid-pagination/GridPagination";
import PageHeader from "../../../../components/page/PageHeader";
import Vue from "vue";
import PageCard from "../../../../components/page/PageCard";

export default {
  mixins: [GridMixin],
  components: {
    PageCard,
    PageHeader,
    FilterInput,
    GridPagination,
  },
  data() {
    return {
      gridGetUrl: '/api/group',
      showDeleted: false,
      orderColumn: null,
      orderDirection: true,
      fields: [
        {key: 'id', sortable: true},
        {key: 'name', label: this.$t('table.header.group_name'), sortable: true},
        {key: 'key', label: this.$t('table.header.group_key')},
        {key: 'usersCount', label: this.$t('table.header.users_in_group')},
        {key: 'rolesCount', label: this.$t('table.header.roles_count')},
        {key: 'actions', label: this.$t('table.header.actions'),  sortable: false},
      ],
      items: [],
      selectOptions: {},
      createModalInstance: null,
      showModalInstance: null,

    };
  },
  methods: {
    showItemDetails(group) {
      this.openModal('show');
      this.showModalInstance.openModal(group);
    },
    editItem(item) {
      this.openModal('create');
      this.createModalInstance.openModal(item);
    },
    deleteItem(item) {
      this.$bvModal.msgBoxConfirm('Group: ' + item.name, {
        title: this.$t('delete.confirm.title.delete_group'),
        okTitle: this.$t('btn.delete'),
        cancelTitle: this.$t('btn.cancel'),
        okVariant: 'danger'
      })
          .then(value => {
            if (value) {
              const data = {data: {id: item.id}};

              axios.delete(`/api/group`, data)
                  .then(() => {
                    this.loadItems();
                  })
                  .catch(() => {
                    alertify.error(this.$t('alertify.msg.group_can_not_be_deleted'));
                  });
            }
          })
    },
    openModal(modalName) {
      let ModalConstructor;
      switch(modalName){
        case('create'): {
          if(!this.createModalInstance){
            ModalConstructor = Vue.extend(CreateSecurityGroupModal);
            this.createModalInstance = new ModalConstructor({parent: this});
            this.createModalInstance.$mount();
            this.createModalInstance.openModal();
            this.createModalInstance.$on('savedRoles', () => {
              this.loadItems();
            });
          } else {
            this.createModalInstance.openModal();
          }
          break;
        }
        case('show'): {
          if(!this.showModalInstance){
            ModalConstructor = Vue.extend(ShowSecurityGroupModal);
            this.showModalInstance = new ModalConstructor({parent: this});
            this.showModalInstance.$mount();
          }
          break;
        }
      }
    }
  },
  watch: {
    showDeleted: function () {
      this.loadItems();
    }
  }
}
</script>
